const betaURL = require("app/util/config/beta-url");
const CardWithLoader = require("../Dashboard/card-with-loader");
const Summary = require("../Dashboard/summary");
const DetailsLink = require("./details-link");
const CenteredCardContent = require("../Dashboard/centered-card-content");

const Reflux = require("reflux");
const LostDealsStore = require("../../stores/lost-deals-store");
const LostDealsActions = require("../../actions/lost-deals-actions");

const currencyFormatter = require("app/util/formatter/currency");
const deltaCalculator = require("./util/delta-type");

const AnimatedValue = require("app/shared/components/AnimatedValue/animated-value");

const LostDealsWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  componentDidMount: function() {
    this.listenTo(LostDealsStore, this.setState);
    this.refresh();
  },

  getInitialState: function() {
    return LostDealsStore.getInitialState();
  },

  componentDidUpdate: function(prevProps) {
    if (prevProps != this.props) {
      this.refresh();
    }
  },

  refresh: function() {
    LostDealsActions.fetchData(
      this.props.period,
      this.props.comparison,
      this.props.users,
      this.props.funnel
    );
  },

  deltaTooltipText: function(value, transform) {
    const comparisonStart = this.props.comparison.startDate.format("DD MMM, YYYY");
    const comparisonEnd = this.props.comparison.endDate.format("DD MMM, YYYY");
    const comparison = `${comparisonStart} - ${comparisonEnd}`;

    if (value === 0) {
      return `Sem mudanças em relação a ${comparison}`;
    }

    const noun = value > 0 ? "Aumento" : "Diminuição";

    return `${noun} de <b>${transform(Math.abs(value))}</b> comparado com ${comparison}`;
  },

  tooltipText: function(value, label) {
    const periodStart = this.props.period.startDate.format("DD MMM, YYYY");
    const periodEnd = this.props.period.endDate.format("DD MMM, YYYY");
    const periodText = `${periodStart} - ${periodEnd}`;

    return `<b>${value}</b>${label ? ' ' + label : ''} em ${periodText}`;
  },

  getDetailsUrl: function() {
    let dateFormat = "YYYY-MM-DD";
    let formattedStartDate = this.props.period.startDate.format(dateFormat);
    let formattedEndDate = this.props.period.endDate.format(dateFormat);

    let searchParams = new URLSearchParams();

    searchParams.append("sn", 3);
    searchParams.append("dci", formattedStartDate);
    searchParams.append("dcf", formattedEndDate);
    searchParams.append("qpp", 25);

    if (this.props.selectedUser)
      searchParams.append("ur", this.props.selectedUser);
    if (this.props.selectedTeam)
      searchParams.append("team", this.props.selectedTeam);
    if (this.props.funnel)
      searchParams.append("funil", this.props.funnel);

    return `${betaURL()}/deals?${searchParams}`;
  },

  render: function() {
    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <p>Negócios perdidos</p>
        }
        footer={<DetailsLink url={this.getDetailsUrl()} />}
      >
        <CenteredCardContent>
          <Summary
            big
            value={<AnimatedValue value={this.state.data.count} />}
            className="mb-20"
            tooltipText={this.tooltipText(this.state.data.count, "negócios perdidos")}
            delta={<AnimatedValue value={this.state.data.countDelta} />}
            deltaTooltipText={this.deltaTooltipText(this.state.data.countDelta, (value) => { return `${value} negócios perdidos`; })}
            deltaType={deltaCalculator.reverseDeltaType(this.state.data.countDelta)}
            url={this.getDetailsUrl()}
          />

          <Summary
            value={<AnimatedValue value={this.state.data.amount} formatter={currencyFormatter.formatCentsToCurrency} />}
            tooltipText={this.tooltipText("Valor total de negócios", "perdidos")}
            delta={<AnimatedValue value={this.state.data.amountDelta} formatter={currencyFormatter.formatCentsToCurrency} />}
            deltaTooltipText={this.deltaTooltipText(this.state.data.amountDelta, currencyFormatter.formatCentsToCurrency)}
            deltaType={deltaCalculator.reverseDeltaType(this.state.data.amountDelta)}
            url={this.getDetailsUrl()}
          />
        </CenteredCardContent>
      </CardWithLoader>
    );
  }
});

module.exports = LostDealsWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/lost-deals-widget.jsx